import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">分类索引</h2>
          <p className="mt-2 text-sm text-foreground-500">按类型快速查找影视内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group flex items-center gap-3 p-3 md:p-4 rounded-lg bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
            >
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-lg text-primary-500`}></i>
              </div>
              <div className="min-w-0">
                <div className="text-sm font-medium text-foreground-800 whitespace-nowrap">{item.title}</div>
                <div className="text-xs text-foreground-500">{item.count}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}